"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttachmentType = exports.AttachmentType = void 0;
var AttachmentType;
(function (AttachmentType) {
    AttachmentType["LESSON_PLAN"] = "LESSON_PLAN";
    AttachmentType["FINAL_PROJECT"] = "FINAL_PROJECT";
    AttachmentType["ACTIVITY"] = "ACTIVITY";
})(AttachmentType || (exports.AttachmentType = AttachmentType = {}));
const getAttachmentType = (value) => {
    const matchedKey = Object.keys(AttachmentType).find((type) => type === value);
    if (!matchedKey) {
        throw Error(`${value} is not a valid attachment type`);
    }
    return AttachmentType[matchedKey];
};
exports.getAttachmentType = getAttachmentType;
//# sourceMappingURL=Attachment.js.map